module.exports = __webpack_public_path__ + "img/Desk Stationary A31.f6f08e8a.jpg";